(function () {
  if (window.LabooWishlist) return;

  var STORAGE_KEY = "laboo:wishlist:v1";
  var MAX_ITEMS = 100;
  var productCache = new Map();
  var pageSelections = new Map();
  var drawerRenderToken = 0;
  var pageRenderToken = 0;
  var scheduledEnhancement = false;
  var activeSizeHandle = "";
  var activeSizeTrigger = null;
  var activeSizeVariants = [];
  var sizeDrawerCloseTimer = 0;
  var US_SIZE_ORDER = [
    "5 x 7 in", "8 x 12 in", "10 x 10 in", "11 x 14 in", "12 x 12 in",
    "12 x 16 in", "14 x 14 in", "16 x 16 in", "16 x 20 in", "16 x 24 in",
    "18 x 18 in", "20 x 20 in", "20 x 28 in", "24 x 32 in", "24 x 36 in",
    "28 x 28 in", "28 x 40 in", "30 x 40 in"
  ];

  function readConfig() {
    var element = document.getElementById("LabooWishlistConfig");
    if (!element) return { rootUrl: "/", wishlistUrl: "/pages/wishlist", labels: {} };

    try {
      return JSON.parse(element.textContent || "{}");
    } catch (error) {
      return { rootUrl: "/", wishlistUrl: "/pages/wishlist", labels: {} };
    }
  }

  var config = readConfig();
  var labels = config.labels || {};

  function normalizedRoot() {
    var root = config.rootUrl || (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return root.charAt(root.length - 1) === "/" ? root : root + "/";
  }

  function readHandles() {
    try {
      var value = JSON.parse(window.localStorage.getItem(STORAGE_KEY));
      if (!Array.isArray(value)) return [];

      return value.filter(function (handle, index, array) {
        return typeof handle === "string" && handle && array.indexOf(handle) === index;
      }).slice(0, MAX_ITEMS);
    } catch (error) {
      return [];
    }
  }

  function saveHandles(handles) {
    try {
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(handles.slice(0, MAX_ITEMS)));
    } catch (error) {
      // The wishlist still behaves for the current render when storage is unavailable.
    }
  }

  function announce(message) {
    var region = document.getElementById("screen-reader-info");
    if (!region) return;
    region.textContent = "";
    window.setTimeout(function () { region.textContent = message; }, 20);
  }

  function dispatchChange(message) {
    var handles = readHandles();
    syncControls();
    if (message) announce(message);

    document.dispatchEvent(new CustomEvent("laboo:wishlist:change", {
      detail: { handles: handles, count: handles.length }
    }));
  }

  function add(handle, title) {
    if (!handle) return;
    var handles = readHandles().filter(function (item) { return item !== handle; });
    handles.unshift(handle);
    saveHandles(handles);
    dispatchChange((labels.add || "Add to wishlist") + (title ? ": " + title : ""));
  }

  function remove(handle, title) {
    if (!handle) return;
    saveHandles(readHandles().filter(function (item) { return item !== handle; }));
    dispatchChange((labels.remove || "Remove from wishlist") + (title ? ": " + title : ""));
  }

  function toggle(handle, title) {
    if (readHandles().indexOf(handle) !== -1) remove(handle, title);
    else add(handle, title);
  }

  function escapeHTML(value) {
    var element = document.createElement("span");
    element.textContent = String(value == null ? "" : value);
    return element.innerHTML;
  }

  function heartSvg() {
    return '<span class="laboo-wishlist-heart__icon" aria-hidden="true"><svg class="laboo-heart-icon" width="22" height="22" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78L12 21.23l8.84-8.84a5.5 5.5 0 0 0 0-7.78Z" fill="currentColor" fill-opacity="0" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"/></svg></span>';
  }

  function syncControls(scope) {
    var handles = readHandles();
    var root = scope || document;

    root.querySelectorAll("[data-laboo-wishlist-toggle]").forEach(function (button) {
      var handle = button.dataset.productHandle || "";
      var title = button.dataset.productTitle || "";
      var saved = handles.indexOf(handle) !== -1;
      var label = (saved ? labels.remove : labels.add) || (saved ? "Remove from wishlist" : "Add to wishlist");

      button.classList.toggle("is-saved", saved);
      button.setAttribute("aria-pressed", String(saved));
      button.setAttribute("aria-label", label + (title ? ": " + title : ""));
      button.setAttribute("title", label);
    });

    document.querySelectorAll("[data-laboo-wishlist-count]").forEach(function (element) {
      element.textContent = String(handles.length);
    });

    document.querySelectorAll(".laboo-wishlist-header-count").forEach(function (element) {
      element.hidden = handles.length === 0;
    });

    document.querySelectorAll("[data-laboo-open-wishlist]").forEach(function (button) {
      button.classList.toggle("has-items", handles.length > 0);
    });
  }

  function imageSource(value) {
    if (!value) return "";
    if (typeof value === "string") return value;
    return value.src || "";
  }

  function resizedImageUrl(value, width) {
    var source = imageSource(value);
    if (!source) return "";

    try {
      var url = new URL(source, window.location.origin);
      url.searchParams.set("width", String(width || 600));
      return url.toString();
    } catch (error) {
      return source;
    }
  }

  function productUrl(handle) {
    return normalizedRoot() + "products/" + encodeURIComponent(handle);
  }

  function productJsonUrl(handle) {
    return productUrl(handle) + ".js";
  }

  function fetchProduct(handle) {
    if (productCache.has(handle)) return productCache.get(handle);

    var request = fetch(productJsonUrl(handle), {
      credentials: "same-origin",
      headers: { "X-Requested-With": "XMLHttpRequest" }
    }).then(function (response) {
      if (!response.ok) throw new Error("Product request failed");
      return response.json();
    }).catch(function () {
      return null;
    });

    productCache.set(handle, request);
    return request;
  }

  async function loadProducts(handles) {
    var products = new Array(handles.length);
    var nextIndex = 0;
    var workerCount = Math.min(4, handles.length);
    var workers = Array.from({ length: workerCount }, async function () {
      while (nextIndex < handles.length) {
        var index = nextIndex++;
        products[index] = await fetchProduct(handles[index]);
      }
    });

    await Promise.all(workers);
    return products;
  }

  function formatMoney(cents) {
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return (Number(cents || 0) / 100).toFixed(2) + " " + currency;
    }
  }

  function formatDrawerMoney(cents) {
    var amount = Number(cents || 0) / 100;
    var currency = (window.Shopify && Shopify.currency && Shopify.currency.active) || "GBP";
    var fractionDigits = Math.abs(Number(cents || 0)) % 100 === 0 ? 0 : 2;

    try {
      return new Intl.NumberFormat(document.documentElement.lang || "en", {
        style: "currency",
        currency: currency,
        minimumFractionDigits: fractionDigits,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (error) {
      return formatMoney(cents);
    }
  }

  function normalizeVariantTitle(value) {
    return String(value || "").replace(/^Size:\s*/i, "").trim();
  }

  function displayVariantTitle(value) {
    var title = normalizeVariantTitle(value);
    var formatter = window.LabooMarketSizeLabels && window.LabooMarketSizeLabels.format;
    return typeof formatter === "function" ? formatter(title) : title;
  }

  function availableVariants(product) {
    var seenLabels = new Set();
    var variants = (product.variants || []).filter(function (variant) {
      return variant.available;
    }).map(function (variant) {
      var displayTitle = displayVariantTitle(variant.title);
      if (displayTitle == null || seenLabels.has(displayTitle)) return null;
      seenLabels.add(displayTitle);
      return { variant: variant, label: displayTitle || variant.title };
    }).filter(Boolean);

    var isUS = window.LabooMarketSizeLabels && window.LabooMarketSizeLabels.isUSMarket && window.LabooMarketSizeLabels.isUSMarket();
    if (isUS) {
      variants.sort(function (a, b) {
        var aIndex = US_SIZE_ORDER.indexOf(a.label);
        var bIndex = US_SIZE_ORDER.indexOf(b.label);
        return (aIndex < 0 ? 999 : aIndex) - (bIndex < 0 ? 999 : bIndex);
      });
    }

    return variants;
  }

  function productPrices(product) {
    var variants = availableVariants(product);
    var lowest = variants.slice().sort(function (a, b) {
      return Number(a.variant.price || 0) - Number(b.variant.price || 0);
    })[0];

    return {
      price: lowest ? Number(lowest.variant.price || 0) : Number(product.price || 0),
      compare: lowest ? Number(lowest.variant.compare_at_price || 0) : Number(product.compare_at_price || 0)
    };
  }

  function priceMarkup(price, compare, prefix) {
    return (prefix ? '<span class="laboo-wishlist-price-prefix">' + escapeHTML(prefix) + "</span> " : "") +
      "<span>" + escapeHTML(formatMoney(price)) + "</span>" +
      (Number(compare) > Number(price) ? " <del>" + escapeHTML(formatMoney(compare)) + "</del>" : "");
  }

  function drawerItemMarkup(product) {
    var prices = productPrices(product);
    var title = product.title || "";
    var handle = product.handle || "";
    var url = productUrl(handle);
    var image = resizedImageUrl(product.featured_image || (product.images && product.images[0]), 260);

    return '<article class="laboo-wishlist-drawer__item" data-laboo-wishlist-product="' + escapeHTML(handle) + '">' +
      '<a class="laboo-wishlist-drawer__image-link" href="' + escapeHTML(url) + '">' +
        '<img class="laboo-wishlist-drawer__image" src="' + escapeHTML(image) + '" alt="' + escapeHTML(title) + '" loading="lazy" width="164" height="205">' +
      "</a>" +
      '<div class="laboo-wishlist-drawer__details">' +
        '<a class="laboo-wishlist-drawer__title" href="' + escapeHTML(url) + '">' + escapeHTML(title) + "</a>" +
        '<div class="laboo-wishlist-drawer__price">' + priceMarkup(prices.price, prices.compare, labels.from || "From") + "</div>" +
      "</div>" +
      '<button type="button" class="laboo-wishlist-heart laboo-wishlist-drawer__remove is-saved" data-laboo-wishlist-toggle data-product-handle="' + escapeHTML(handle) + '" data-product-title="' + escapeHTML(title) + '" aria-pressed="true">' + heartSvg() + "</button>" +
    "</article>";
  }

  async function renderDrawer() {
    var drawer = document.getElementById("site-cart-sidebar");
    if (!drawer) return;

    var list = drawer.querySelector("[data-laboo-wishlist-drawer-list]");
    var empty = drawer.querySelector("[data-laboo-wishlist-drawer-empty]");
    var status = drawer.querySelector("[data-laboo-wishlist-drawer-status]");
    if (!list || !empty || !status) return;

    var handles = readHandles();
    var token = ++drawerRenderToken;
    list.innerHTML = "";

    if (!handles.length) {
      status.textContent = "";
      empty.hidden = false;
      return;
    }

    empty.hidden = true;
    status.textContent = labels.loading || "Loading saved items...";
    var products = await loadProducts(handles);
    if (token !== drawerRenderToken) return;

    list.innerHTML = products.filter(Boolean).map(drawerItemMarkup).join("");
    status.textContent = "";
    empty.hidden = list.children.length > 0;
    syncControls(list);
  }

  function switchDrawer(view) {
    var drawer = document.getElementById("site-cart-sidebar");
    if (!drawer) return;

    var wishlistView = view === "wishlist";
    drawer.classList.toggle("laboo-wishlist-view", wishlistView);

    var wishlistPanel = drawer.querySelector("#laboo-wishlist-panel");
    var cartPanel = drawer.querySelector("#laboo-cart-panel");
    var wishlistTitle = drawer.querySelector("[data-laboo-wishlist-drawer-title]");
    var cartTitle = drawer.querySelector("[data-laboo-cart-drawer-title]");

    if (wishlistPanel) wishlistPanel.hidden = !wishlistView;
    if (cartPanel) cartPanel.hidden = wishlistView;
    if (wishlistTitle) wishlistTitle.hidden = !wishlistView;
    if (cartTitle) cartTitle.hidden = wishlistView;

    drawer.querySelectorAll("[data-laboo-drawer-tab]").forEach(function (tab) {
      var selected = tab.dataset.labooDrawerTab === view;
      tab.classList.toggle("is-active", selected);
      tab.setAttribute("aria-selected", String(selected));
      tab.setAttribute("tabindex", selected ? "0" : "-1");
    });

    if (wishlistView) renderDrawer();
  }

  function openWishlistDrawer() {
    var drawer = document.getElementById("site-cart-sidebar");
    if (!drawer || typeof drawer.show !== "function") {
      window.location.href = config.wishlistUrl || normalizedRoot() + "pages/wishlist";
      return;
    }

    switchDrawer("wishlist");
    drawer.show();
    document.querySelectorAll("[data-laboo-open-wishlist]").forEach(function (button) {
      button.setAttribute("aria-expanded", "true");
    });
  }

  function sizeDrawerElements() {
    var drawer = document.querySelector("[data-laboo-wishlist-size-drawer]");
    return {
      drawer: drawer,
      panel: drawer && drawer.querySelector(".laboo-wishlist-size-drawer__panel"),
      list: drawer && drawer.querySelector("[data-laboo-wishlist-size-list]"),
      status: drawer && drawer.querySelector("[data-laboo-wishlist-size-status]")
    };
  }

  function lockSizeDrawerScroll() {
    var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
    document.documentElement.style.setProperty("--laboo-wishlist-scrollbar-width", scrollbarWidth + "px");
    document.documentElement.classList.add("laboo-wishlist-size-drawer-open");
    document.body.classList.add("laboo-wishlist-size-drawer-open");
  }

  function unlockSizeDrawerScroll() {
    document.documentElement.classList.remove("laboo-wishlist-size-drawer-open");
    document.body.classList.remove("laboo-wishlist-size-drawer-open");
    document.documentElement.style.removeProperty("--laboo-wishlist-scrollbar-width");
  }

  function sizeOptionMarkup(entry, selectedId) {
    var variant = entry.variant;
    var selected = String(variant.id) === String(selectedId);
    var compare = Number(variant.compare_at_price || 0);
    var price = Number(variant.price || 0);

    return '<button type="button" class="laboo-wishlist-size-drawer__option' + (selected ? " is-selected" : "") + '"' +
      ' data-laboo-wishlist-size-option data-variant-id="' + escapeHTML(variant.id) + '" aria-pressed="' + String(selected) + '">' +
        '<span class="laboo-wishlist-size-drawer__label">' + escapeHTML(entry.label) + "</span>" +
        '<span class="laboo-wishlist-size-drawer__prices">' +
          '<span class="laboo-wishlist-size-drawer__price">' + escapeHTML(formatDrawerMoney(price)) + "</span>" +
          (compare > price ? '<del class="laboo-wishlist-size-drawer__compare">' + escapeHTML(formatDrawerMoney(compare)) + "</del>" : "") +
        "</span>" +
      "</button>";
  }

  function closeWishlistSizeDrawer(restoreFocus) {
    var elements = sizeDrawerElements();
    if (!elements.drawer || elements.drawer.hidden) return;

    window.clearTimeout(sizeDrawerCloseTimer);
    elements.drawer.classList.remove("is-open");
    if (activeSizeTrigger) activeSizeTrigger.setAttribute("aria-expanded", "false");

    var returnFocus = restoreFocus ? activeSizeTrigger : null;
    sizeDrawerCloseTimer = window.setTimeout(function () {
      elements.drawer.hidden = true;
      unlockSizeDrawerScroll();
      activeSizeHandle = "";
      activeSizeTrigger = null;
      activeSizeVariants = [];
      if (returnFocus && document.contains(returnFocus)) returnFocus.focus({ preventScroll: true });
    }, 260);
  }

  function openWishlistSizeDrawer(handle, trigger) {
    var elements = sizeDrawerElements();
    if (!elements.drawer || !elements.list || !elements.status || !handle) return;

    window.clearTimeout(sizeDrawerCloseTimer);
    if (activeSizeTrigger && activeSizeTrigger !== trigger) {
      activeSizeTrigger.setAttribute("aria-expanded", "false");
    }

    activeSizeHandle = handle;
    activeSizeTrigger = trigger;
    activeSizeVariants = [];
    trigger.setAttribute("aria-expanded", "true");
    elements.list.innerHTML = "";
    elements.status.textContent = labels.loading || "Loading saved items...";
    elements.drawer.hidden = false;
    lockSizeDrawerScroll();

    window.requestAnimationFrame(function () {
      elements.drawer.classList.add("is-open");
    });

    fetchProduct(handle).then(function (product) {
      if (!product || activeSizeHandle !== handle || elements.drawer.hidden) return;

      activeSizeVariants = availableVariants(product);
      var selectedId = String(pageSelections.get(handle) || (activeSizeVariants[0] && activeSizeVariants[0].variant.id) || "");
      if (selectedId) pageSelections.set(handle, selectedId);

      elements.status.textContent = activeSizeVariants.length ? "" : (labels.unavailable || "Unavailable");
      elements.list.innerHTML = activeSizeVariants.map(function (entry) {
        return sizeOptionMarkup(entry, selectedId);
      }).join("");

      var selectedOption = elements.list.querySelector(".is-selected");
      if (selectedOption) selectedOption.scrollIntoView({ block: "nearest" });
      var closeButton = elements.drawer.querySelector("[data-laboo-wishlist-size-close]");
      if (closeButton) closeButton.focus({ preventScroll: true });
    });
  }

  function updateWishlistCardSelection(entry) {
    if (!entry || !activeSizeHandle || !activeSizeTrigger) return;

    var variant = entry.variant;
    var card = activeSizeTrigger.closest("[data-laboo-wishlist-card]");
    pageSelections.set(activeSizeHandle, variant.id);
    activeSizeTrigger.dataset.selectedVariantId = String(variant.id);

    var label = activeSizeTrigger.querySelector("[data-laboo-wishlist-selected-size]");
    if (label) label.textContent = entry.label;
    activeSizeTrigger.setAttribute("aria-label", (labels.selectSize || "Select size") + ": " + entry.label);

    var price = card && card.querySelector("[data-laboo-wishlist-card-price]");
    if (price) price.innerHTML = priceMarkup(variant.price, variant.compare_at_price);
  }

  function trapSizeDrawerFocus(event) {
    var elements = sizeDrawerElements();
    if (!elements.drawer || elements.drawer.hidden) return;

    if (event.key === "Escape") {
      event.preventDefault();
      closeWishlistSizeDrawer(true);
      return;
    }

    if (event.key !== "Tab") return;
    var focusable = Array.from(elements.drawer.querySelectorAll("button:not([disabled])"));
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];

    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  }

  function productCardMarkup(product) {
    var handle = product.handle || "";
    var title = product.title || "";
    var url = productUrl(handle);
    var image = resizedImageUrl(product.featured_image || (product.images && product.images[0]), 700);
    var isTrio = (handle === "italian-kitchen-prints-pasta-set-of-3" || handle === "neutral-dining-room-wall-art-set-of-3");
    if (isTrio || product.type === "Gallery Wall Art") {
      return '<article class="laboo-wishlist-card" data-laboo-wishlist-card="' + escapeHTML(handle) + '">' +
        '<a class="laboo-wishlist-card__image-link" href="' + escapeHTML(url) + '"><img class="laboo-wishlist-card__image" src="' + escapeHTML(image) + '" alt="' + escapeHTML(title) + '" loading="lazy" width="700" height="875"></a>' +
        '<button type="button" class="laboo-wishlist-heart is-saved" data-laboo-wishlist-toggle data-product-handle="' + escapeHTML(handle) + '" data-product-title="' + escapeHTML(title) + '" aria-pressed="true">' + heartSvg() + '</button>' +
        '<a class="laboo-wishlist-card__title" href="' + escapeHTML(url) + '">' + escapeHTML(title) + '</a>' +
        '<div class="laboo-wishlist-card__price">' + priceMarkup(product.price, product.compare_at_price) + '</div>' +
        '<a class="laboo-wishlist-card__add" href="' + escapeHTML(url) + '">' + (isTrio ? "Choose trio sizes" : "Choose set sizes") + '</a></article>';
    }
    var variants = availableVariants(product);
    var selectedId = String(pageSelections.get(handle) || (variants[0] && variants[0].variant.id) || "");
    var selected = variants.find(function (entry) { return String(entry.variant.id) === selectedId; }) || variants[0];

    if (selected) pageSelections.set(handle, selected.variant.id);

    var price = selected ? selected.variant.price : product.price;
    var compare = selected ? selected.variant.compare_at_price : product.compare_at_price;
    var selectedLabel = selected ? selected.label : (labels.unavailable || "Unavailable");

    return '<article class="laboo-wishlist-card" data-laboo-wishlist-card="' + escapeHTML(handle) + '">' +
      '<a class="laboo-wishlist-card__image-link" href="' + escapeHTML(url) + '">' +
        '<img class="laboo-wishlist-card__image" src="' + escapeHTML(image) + '" alt="' + escapeHTML(title) + '" loading="lazy" width="700" height="875">' +
      "</a>" +
      '<button type="button" class="laboo-wishlist-heart is-saved" data-laboo-wishlist-toggle data-product-handle="' + escapeHTML(handle) + '" data-product-title="' + escapeHTML(title) + '" aria-pressed="true">' + heartSvg() + "</button>" +
      '<a class="laboo-wishlist-card__title" href="' + escapeHTML(url) + '">' + escapeHTML(title) + "</a>" +
      '<div class="laboo-wishlist-card__price" data-laboo-wishlist-card-price>' + priceMarkup(price, compare) + "</div>" +
      '<div class="laboo-wishlist-card__controls">' +
        '<button type="button" class="laboo-wishlist-card__select laboo-wishlist-card__size-trigger" data-laboo-wishlist-size-trigger="' + escapeHTML(handle) + '" data-selected-variant-id="' + escapeHTML(selected ? selected.variant.id : "") + '" aria-haspopup="dialog" aria-controls="LabooWishlistSizeDrawer" aria-expanded="false" aria-label="' + escapeHTML((labels.selectSize || "Select size") + ": " + selectedLabel) + '"' + (variants.length ? "" : " disabled") + ">" +
          '<span data-laboo-wishlist-selected-size>' + escapeHTML(selectedLabel) + "</span>" +
          '<span class="laboo-wishlist-card__size-chevron" aria-hidden="true">&#8250;</span>' +
        "</button>" +
        '<button type="button" class="laboo-wishlist-card__add" data-laboo-wishlist-add="' + escapeHTML(handle) + '"' + (variants.length ? "" : " disabled") + ">" + escapeHTML(labels.addToCart || "Add to cart") + "</button>" +
      "</div>" +
    "</article>";
  }

  async function renderPage() {
    var page = document.querySelector("[data-laboo-wishlist-page]");
    if (!page) return;

    var grid = page.querySelector("[data-laboo-wishlist-page-grid]");
    var status = page.querySelector("[data-laboo-wishlist-page-status]");
    var empty = page.querySelector("[data-laboo-wishlist-page-empty]");
    var footer = page.querySelector("[data-laboo-wishlist-page-footer]");
    var handles = readHandles();
    var token = ++pageRenderToken;

    if (!handles.length) {
      if (grid) grid.innerHTML = "";
      if (status) status.textContent = "";
      if (empty) empty.hidden = false;
      if (footer) footer.hidden = true;
      return;
    }

    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    if (status) status.textContent = labels.loading || "Loading saved items...";

    var products = await loadProducts(handles);
    if (token !== pageRenderToken) return;

    if (grid) {
      grid.innerHTML = products.filter(Boolean).map(productCardMarkup).join("");
      syncControls(grid);
    }
    if (status) status.textContent = "";
  }

  function renderCartDrawer(html) {
    if (!html) return;
    var section = new DOMParser().parseFromString(html, "text/html");
    var incomingForm = section.getElementById("AjaxCartForm");
    var incomingSubtotal = section.getElementById("AjaxCartSubtotal");
    var currentForm = document.getElementById("AjaxCartForm");
    var currentSubtotal = document.getElementById("AjaxCartSubtotal");
    if (!incomingForm || !incomingSubtotal || !currentForm || !currentSubtotal) return;

    currentForm.innerHTML = incomingForm.innerHTML;
    currentSubtotal.innerHTML = incomingSubtotal.innerHTML;
    if (typeof currentForm.ajaxifyCartItems === "function") currentForm.ajaxifyCartItems();

    var count = currentForm.querySelector("[data-cart-count]");
    var total = currentForm.querySelector("[data-cart-total]");
    document.querySelectorAll("[data-header-cart-count]").forEach(function (element) {
      if (count) element.textContent = count.textContent;
    });
    document.querySelectorAll("[data-header-cart-total]").forEach(function (element) {
      if (total) element.textContent = total.textContent;
    });

    var drawer = document.getElementById("site-cart-sidebar");
    if (drawer && count) {
      var itemCount = parseInt(count.textContent, 10) || 0;
      drawer.classList.toggle("cart-is-empty", itemCount === 0);
      drawer.dataset.cartItems = String(itemCount);
    }
  }

  async function addItems(items, trigger) {
    if (!items.length) return;
    var originalLabel = trigger ? trigger.textContent : "";
    if (trigger) {
      trigger.disabled = true;
      trigger.setAttribute("aria-busy", "true");
      trigger.textContent = labels.adding || "Adding...";
    }

    try {
      var addUrl = (window.KROWN && KROWN.settings && KROWN.settings.routes && KROWN.settings.routes.cart_add_url) || normalizedRoot() + "cart/add";
      if (!/\.js(?:\?|$)/.test(addUrl)) addUrl += ".js";
      var options = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "Accept": "application/json",
          "X-Requested-With": "XMLHttpRequest"
        },
        body: JSON.stringify({ items: items })
      };
      var response;

      if (typeof window.labooCartRequest === "function") {
        response = await window.labooCartRequest(addUrl, options);
      } else {
        var nativeResponse = await fetch(addUrl, options);
        response = await nativeResponse.json().catch(function () { return {}; });
        if (!response.status) response.status = nativeResponse.status;
      }

      if (response && Number(response.status) >= 400) throw new Error(response.description || "Cart request failed");

      var sectionText = typeof window.labooCartSectionText === "function"
        ? await window.labooCartSectionText(response)
        : await fetch("?section_id=helper-cart", { credentials: "same-origin" }).then(function (sectionResponse) { return sectionResponse.text(); });

      renderCartDrawer(sectionText);
      switchDrawer("cart");
      var drawer = document.getElementById("site-cart-sidebar");
      if (drawer && typeof drawer.show === "function") drawer.show();
      document.dispatchEvent(new CustomEvent("laboo:wishlist:added-to-cart", { detail: { items: items } }));
    } catch (error) {
      announce(error.message || "Cart request failed");
    } finally {
      if (trigger) {
        trigger.disabled = false;
        trigger.removeAttribute("aria-busy");
        trigger.textContent = originalLabel;
      }
    }
  }

  function selectedVariantForHandle(handle) {
    if ((handle === "italian-kitchen-prints-pasta-set-of-3" || handle === "neutral-dining-room-wall-art-set-of-3")) return Promise.resolve(null);
    var cached = productCache.get(handle);
    if (!cached) return Promise.resolve(null);

    return cached.then(function (product) {
      if (!product || product.type === "Gallery Wall Art") return null;
      var id = String(pageSelections.get(handle) || "");
      return (product.variants || []).find(function (variant) {
        return String(variant.id) === id && variant.available;
      }) || null;
    });
  }

  function handleFromProductLink(link) {
    if (!link) return "";
    try {
      var match = new URL(link.href, window.location.origin).pathname.match(/\/products\/([^/?#]+)/);
      return match ? decodeURIComponent(match[1]) : "";
    } catch (error) {
      return "";
    }
  }

  function createDynamicHeart(handle, title) {
    var button = document.createElement("button");
    button.type = "button";
    button.className = "laboo-wishlist-heart";
    button.dataset.labooWishlistToggle = "";
    button.dataset.productHandle = handle;
    button.dataset.productTitle = title || "";
    button.innerHTML = heartSvg();
    return button;
  }

  function enhanceDynamicCards() {
    document.querySelectorAll(".rvp-item, .snize-product").forEach(function (card) {
      if (card.querySelector("[data-laboo-wishlist-toggle]")) return;
      var handle = card.dataset.labooProductHandle || handleFromProductLink(card.querySelector('a[href*="/products/"]'));
      if (!handle) return;
      var titleElement = card.querySelector(".snize-title, .snize-product-title, [data-product-title]");
      var title = card.dataset.labooProductTitle || (titleElement && titleElement.textContent.trim()) || "";
      card.classList.add("laboo-wishlist-dynamic-card");
      // 1 Nov 2026: beside the name when the card has a title row (Recently Viewed), otherwise on the card as before
      (card.querySelector(".laboo-card-title-row") || card).appendChild(createDynamicHeart(handle, title));
    });
    syncControls();
  }

  function scheduleEnhancement() {
    if (scheduledEnhancement) return;
    scheduledEnhancement = true;
    window.requestAnimationFrame(function () {
      scheduledEnhancement = false;
      enhanceDynamicCards();
    });
  }

  document.addEventListener("click", function (event) {
    var sizeClose = event.target.closest("[data-laboo-wishlist-size-close]");
    if (sizeClose) {
      event.preventDefault();
      closeWishlistSizeDrawer(true);
      return;
    }

    var sizeOption = event.target.closest("[data-laboo-wishlist-size-option]");
    if (sizeOption) {
      event.preventDefault();
      var selectedEntry = activeSizeVariants.find(function (entry) {
        return String(entry.variant.id) === String(sizeOption.dataset.variantId);
      });
      updateWishlistCardSelection(selectedEntry);
      closeWishlistSizeDrawer(true);
      return;
    }

    var sizeTrigger = event.target.closest("[data-laboo-wishlist-size-trigger]");
    if (sizeTrigger) {
      event.preventDefault();
      event.stopPropagation();
      openWishlistSizeDrawer(sizeTrigger.dataset.labooWishlistSizeTrigger, sizeTrigger);
      return;
    }

    var toggleButton = event.target.closest("[data-laboo-wishlist-toggle]");
    if (toggleButton) {
      if (toggleButton.classList.contains("laboo-product-gallery-wishlist")) return;
      event.preventDefault();
      event.stopPropagation();
      toggle(toggleButton.dataset.productHandle || "", toggleButton.dataset.productTitle || "");
      return;
    }

    var openButton = event.target.closest("[data-laboo-open-wishlist]");
    if (openButton) {
      event.preventDefault();
      event.stopPropagation();
      openWishlistDrawer();
      return;
    }

    var tab = event.target.closest("[data-laboo-drawer-tab]");
    if (tab) {
      event.preventDefault();
      switchDrawer(tab.dataset.labooDrawerTab);
      return;
    }

    if (event.target.closest('.area--cart[aria-controls="site-cart-sidebar"]')) {
      switchDrawer("cart");
      return;
    }

    var addButton = event.target.closest("[data-laboo-wishlist-add]");
    if (addButton) {
      event.preventDefault();
      selectedVariantForHandle(addButton.dataset.labooWishlistAdd).then(function (variant) {
        if (variant) addItems([{ id: Number(variant.id), quantity: 1 }], addButton);
      });
      return;
    }

    var addAllButton = event.target.closest("[data-laboo-wishlist-add-all]");
    if (addAllButton) {
      event.preventDefault();
      var handles = Array.from(document.querySelectorAll("[data-laboo-wishlist-page] [data-laboo-wishlist-card]")).map(function (card) {
        return card.dataset.labooWishlistCard;
      });
      Promise.all(handles.map(selectedVariantForHandle)).then(function (variants) {
        var items = variants.filter(Boolean).map(function (variant) {
          return { id: Number(variant.id), quantity: 1 };
        });
        addItems(items, addAllButton);
      });
    }
  }, true);

  document.addEventListener("keydown", trapSizeDrawerFocus);

  document.addEventListener("laboo:wishlist:change", function () {
    if (activeSizeHandle && readHandles().indexOf(activeSizeHandle) === -1) {
      closeWishlistSizeDrawer(false);
    }
    var drawer = document.getElementById("site-cart-sidebar");
    if (drawer && drawer.classList.contains("laboo-wishlist-view")) renderDrawer();
    renderPage();
  });

  window.addEventListener("storage", function (event) {
    if (event.key !== STORAGE_KEY) return;
    dispatchChange();
  });

  function initialize() {
    syncControls();
    enhanceDynamicCards();
    renderPage();

    new MutationObserver(function (mutations) {
      var relevant = mutations.some(function (mutation) {
        return Array.prototype.some.call(mutation.addedNodes, function (node) {
          return node.nodeType === 1 && (
            node.matches(".rvp-item, .snize-product, [data-laboo-wishlist-toggle], [data-laboo-open-wishlist]") ||
            node.querySelector(".rvp-item, .snize-product, [data-laboo-wishlist-toggle], [data-laboo-open-wishlist]")
          );
        });
      });
      if (relevant) scheduleEnhancement();
    }).observe(document.body, { childList: true, subtree: true });
  }

  window.LabooWishlist = {
    getHandles: readHandles,
    has: function (handle) { return readHandles().indexOf(handle) !== -1; },
    add: add,
    remove: remove,
    toggle: toggle,
    open: openWishlistDrawer,
    refresh: dispatchChange
  };

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initialize, { once: true });
  } else {
    initialize();
  }
})();
